import { resizeObservers as r } from "../utils/resizeObservers.js";
var t = function() {
  return r.some(function(e) {
    return e.skippedTargets.length > 0;
  });
};
export {
  t as hasSkippedObservations
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js
// module id = 1313
// module chunks = 41